export default "__VITE_ASSET__92acaa40__"